import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UnsavedChangesProvider } from './lib/unsaved-changes.js';
import { App } from './App.js';
import { AuthProvider } from './auth/AuthProvider.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root が見つかりません');

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AuthProvider>
        <UnsavedChangesProvider>
          <App />
        </UnsavedChangesProvider>
      </AuthProvider>
    ),
  },
]);

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
